export interface Header {
  headerName: string;
  translateHeaderName: string;
  headerSubtitle?: string;
  iconAddr?: string;
  classname?: string;
  typeStr?: string;
  positionTypeStr?: string;
  extraTypeStr?: ExtraType;
  groupName?: string | null;
  parentGroupName?: string | null;
  parentGroupOrder?: number | null;
  tag?: number | string | null;
}

export enum ExtraType {
  NoExtra = "NoExtra",
  WithChart = "WithChart",
}

export interface TableIconLinkValue {
  text: string;
  href: string;
  icon: string;
  title?: string;
}

export interface TableProgressBarValue {
  value: number;
  total: number;
  text?: string;
}

export interface TableHoverTableValue {
  text: string;
  headers: string[];
  rows: string[][];
}

export interface ITableReport {
  id: number;
  row: number;
  rowName?: string;
}

export interface IAccordionTableRow extends ITableReport {
  isFooter?: boolean;
  groupName?: string | null;
}
export interface ISearchParameters {}

export interface IAddNewData {}

export interface INoNewData extends IAddNewData {}
export interface Report<T extends ITableReport> {
  count?: number;
  offset?: number;
  pageSize?: number;
  report: Array<T>;
  translatedHeaders: Array<Header>;
  requestDate?: string;
  footer?: Array<T>;
}

export enum TableHeaderState {
  Auto = "Auto",
  Hidden = "Hidden",
  FirstPage = "FirstPage",
  Mediator = "Mediator",
  DefaultHidden = "DefaultHidden",
}

export interface ITableHeaderState {
  [headerName: string]: TableHeaderState;
}
